import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Link } from 'react-router-dom';
import EventsList from '@Components/Events/List';
import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';

export default function EventsListView() {
  return (
    <div>
      <Breadcrumbs
        navList={[
          { name: 'Events', href: '/events' },
          { name: 'General', href: '/events/general' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Events</Heading>
        </div>
        <Button variant="primary" asChild>
          <Link to="/events/create">Create new event</Link>
        </Button>
      </div>
      <EventsList />
    </div>
  );
}
